export default __webpack_public_path__ + "static/logo-simple-white-853113c461b1b6c8f850c4104b878d39.png";